import React from 'react';
import { Link } from 'react-router-dom';
import styles from './user-menu.module.scss';
import userIconUrl from '../../../assets/svg/user-nav.svg';
import { LoggedInLink, UserMenuViewProps } from '../types';

/**
 * Build logged-in links. Travel app is traveler-only.
 * Using relative paths for in-app navigation (no need for TRIPS_URL for local pages).
 * Exported for use by user-menu-container.
 */
export function getLoggedInLinks(): LoggedInLink[] {
  return [
    {
      icon: <img src={userIconUrl} alt="" className={styles['account-icon']} aria-hidden />,
      label: 'Account',
      href: '/account',
    },
    {
      label: 'My Trips',
      href: '/',
    },
  ];
}

const UserMenuView = ({
  loggedIn = null,
  loggedInLinks,
  onClickLink,
}: UserMenuViewProps) => (
  <div className={styles['user-menu']} data-dropdown aria-label="User account menu" role="navigation">
    <img src={userIconUrl} alt="" className={styles['user-menu-icon']} aria-hidden="true" />
    <div className={styles['user-menu-links']}>
      {loggedIn ? (
        <>
          {loggedInLinks.map((link) => (
            <Link
              className={`${styles.login} ztest-login`}
              to={link.href}
              key={link.label}
              onClick={onClickLink}
            >
              {link.icon}
              <span>{link.label}</span>
            </Link>
          ))}
          <a
            className={`${styles.login} ztest-login`}
            href="/logout"
            rel="nofollow"
          >
            <span>Logout</span>
          </a>
        </>
      ) : (
        <>
          <Link
            className={`${styles.login} ztest-login`}
            to="/login?redirect=account"
            onClick={onClickLink}
          >
            <img src={userIconUrl} alt="" className={styles['account-icon']} aria-hidden />
            <span>Account</span>
          </Link>
          <Link
            className={`${styles.login} ztest-login`}
            to="/login"
            onClick={onClickLink}
          >
            <span>My Trips</span>
          </Link>
        </>
      )}
    </div>
  </div>
);

export default UserMenuView;
